/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ArticleDetailsResponse } from '../models';
// @ts-ignore
import type { CurrentRatingsResponse } from '../models';
// @ts-ignore
import type { RatingHistoriesResponse } from '../models';
// @ts-ignore
import type { ScheduledTaskTriggerResponse } from '../models';
// @ts-ignore
import type { SimpleArticle } from '../models';
/**
 * SeekingAlphaApi - axios parameter creator
 * @export
 */
export const SeekingAlphaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve detailed information for a specific article by ID from SeekingAlpha
         * @summary Get article details
         * @param {GetArticleDetailsCredentialKeyEnum} credentialKey 
         * @param {string} articleId 
         * @param {boolean} [forceBedrockVerification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetails: async (credentialKey: GetArticleDetailsCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialKey' is not null or undefined
            assertParamExists('getArticleDetails', 'credentialKey', credentialKey)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleDetails', 'articleId', articleId)
            const localVarPath = `/api/seeking-alpha/article/{credentialKey}/{articleId}`
                .replace(`{${"credentialKey"}}`, encodeURIComponent(String(credentialKey)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (forceBedrockVerification !== undefined) {
                localVarQueryParameter['forceBedrockVerification'] = forceBedrockVerification;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information for a specific article by ID from SeekingAlpha using direct credential lookup (bypassing cache)
         * @summary Get article details with direct credential lookup
         * @param {GetArticleDetailsWithDirectCredentialCredentialKeyEnum} credentialKey 
         * @param {string} articleId 
         * @param {boolean} [forceBedrockVerification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetailsWithDirectCredential: async (credentialKey: GetArticleDetailsWithDirectCredentialCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialKey' is not null or undefined
            assertParamExists('getArticleDetailsWithDirectCredential', 'credentialKey', credentialKey)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleDetailsWithDirectCredential', 'articleId', articleId)
            const localVarPath = `/api/seeking-alpha/article-direct/{credentialKey}/{articleId}`
                .replace(`{${"credentialKey"}}`, encodeURIComponent(String(credentialKey)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (forceBedrockVerification !== undefined) {
                localVarQueryParameter['forceBedrockVerification'] = forceBedrockVerification;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the current SeekingAlpha rating snapshot (quant, authors, sell-side and factor grades) for a comma-separated list of ticker symbols. Cached server-side; unavailable tickers are returned with available=false.
         * @summary Get current ratings for multiple tickers
         * @param {string} tickers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRatings: async (tickers: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tickers' is not null or undefined
            assertParamExists('getCurrentRatings', 'tickers', tickers)
            const localVarPath = `/api/seeking-alpha/ratings/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tickers !== undefined) {
                localVarQueryParameter['tickers'] = tickers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the latest published stock articles from SeekingAlpha
         * @summary Get latest published stock articles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPublishedStock: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/seeking-alpha/latest-published-stock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve market cap value for a specific ticker symbol from SeekingAlpha
         * @summary Get market cap for ticker
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketCap: async (ticker: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getMarketCap', 'ticker', ticker)
            const localVarPath = `/api/seeking-alpha/market-cap/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the rating histories (quant, authors, sell-side ratings and factor grades) for a specific ticker symbol from SeekingAlpha
         * @summary Get rating histories for ticker
         * @param {string} ticker 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingHistories: async (ticker: string, pageNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getRatingHistories', 'ticker', ticker)
            const localVarPath = `/api/seeking-alpha/symbol/{ticker}/rating-histories`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve Pro Quant Portfolio articles as simplified article list from SeekingAlpha
         * @summary Get simplified Pro Quant Portfolio articles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleProQuantPortfolioArticles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/seeking-alpha/pro-quant-portfolio/simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger the SeekingAlpha scheduled trading task manually, bypassing the first working day validation. Optional simulation parameters allow testing with a specific article.
         * @summary Manually trigger scheduled trading task
         * @param {TriggerScheduledTaskCredentialKeyEnum} [credentialKey] 
         * @param {TriggerScheduledTaskRunModeEnum} [runMode] 
         * @param {string} [mockArticleId] 
         * @param {number} [mockInjectAtAttempt] 
         * @param {number} [parallelJobs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerScheduledTask: async (credentialKey?: TriggerScheduledTaskCredentialKeyEnum, runMode?: TriggerScheduledTaskRunModeEnum, mockArticleId?: string, mockInjectAtAttempt?: number, parallelJobs?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/seeking-alpha/trigger-scheduled-task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (credentialKey !== undefined) {
                localVarQueryParameter['credentialKey'] = credentialKey;
            }

            if (runMode !== undefined) {
                localVarQueryParameter['runMode'] = runMode;
            }

            if (mockArticleId !== undefined) {
                localVarQueryParameter['mockArticleId'] = mockArticleId;
            }

            if (mockInjectAtAttempt !== undefined) {
                localVarQueryParameter['mockInjectAtAttempt'] = mockInjectAtAttempt;
            }

            if (parallelJobs !== undefined) {
                localVarQueryParameter['parallelJobs'] = parallelJobs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SeekingAlphaApi - functional programming interface
 * @export
 */
export const SeekingAlphaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SeekingAlphaApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve detailed information for a specific article by ID from SeekingAlpha
         * @summary Get article details
         * @param {GetArticleDetailsCredentialKeyEnum} credentialKey 
         * @param {string} articleId 
         * @param {boolean} [forceBedrockVerification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleDetails(credentialKey: GetArticleDetailsCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleDetails(credentialKey, articleId, forceBedrockVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getArticleDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information for a specific article by ID from SeekingAlpha using direct credential lookup (bypassing cache)
         * @summary Get article details with direct credential lookup
         * @param {GetArticleDetailsWithDirectCredentialCredentialKeyEnum} credentialKey 
         * @param {string} articleId 
         * @param {boolean} [forceBedrockVerification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleDetailsWithDirectCredential(credentialKey: GetArticleDetailsWithDirectCredentialCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleDetailsWithDirectCredential(credentialKey, articleId, forceBedrockVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getArticleDetailsWithDirectCredential']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the current SeekingAlpha rating snapshot (quant, authors, sell-side and factor grades) for a comma-separated list of ticker symbols. Cached server-side; unavailable tickers are returned with available=false.
         * @summary Get current ratings for multiple tickers
         * @param {string} tickers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentRatings(tickers: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentRatingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentRatings(tickers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getCurrentRatings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the latest published stock articles from SeekingAlpha
         * @summary Get latest published stock articles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestPublishedStock(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleArticle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestPublishedStock(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getLatestPublishedStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve market cap value for a specific ticker symbol from SeekingAlpha
         * @summary Get market cap for ticker
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketCap(ticker: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketCap(ticker, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getMarketCap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the rating histories (quant, authors, sell-side ratings and factor grades) for a specific ticker symbol from SeekingAlpha
         * @summary Get rating histories for ticker
         * @param {string} ticker 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRatingHistories(ticker: string, pageNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RatingHistoriesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRatingHistories(ticker, pageNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getRatingHistories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve Pro Quant Portfolio articles as simplified article list from SeekingAlpha
         * @summary Get simplified Pro Quant Portfolio articles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimpleProQuantPortfolioArticles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleArticle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimpleProQuantPortfolioArticles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.getSimpleProQuantPortfolioArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger the SeekingAlpha scheduled trading task manually, bypassing the first working day validation. Optional simulation parameters allow testing with a specific article.
         * @summary Manually trigger scheduled trading task
         * @param {TriggerScheduledTaskCredentialKeyEnum} [credentialKey] 
         * @param {TriggerScheduledTaskRunModeEnum} [runMode] 
         * @param {string} [mockArticleId] 
         * @param {number} [mockInjectAtAttempt] 
         * @param {number} [parallelJobs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerScheduledTask(credentialKey?: TriggerScheduledTaskCredentialKeyEnum, runMode?: TriggerScheduledTaskRunModeEnum, mockArticleId?: string, mockInjectAtAttempt?: number, parallelJobs?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduledTaskTriggerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerScheduledTask(credentialKey, runMode, mockArticleId, mockInjectAtAttempt, parallelJobs, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SeekingAlphaApi.triggerScheduledTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SeekingAlphaApi - factory interface
 * @export
 */
export const SeekingAlphaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SeekingAlphaApiFp(configuration)
    return {
        /**
         * Retrieve detailed information for a specific article by ID from SeekingAlpha
         * @summary Get article details
         * @param {GetArticleDetailsCredentialKeyEnum} credentialKey 
         * @param {string} articleId 
         * @param {boolean} [forceBedrockVerification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetails(credentialKey: GetArticleDetailsCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDetailsResponse> {
            return localVarFp.getArticleDetails(credentialKey, articleId, forceBedrockVerification, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information for a specific article by ID from SeekingAlpha using direct credential lookup (bypassing cache)
         * @summary Get article details with direct credential lookup
         * @param {GetArticleDetailsWithDirectCredentialCredentialKeyEnum} credentialKey 
         * @param {string} articleId 
         * @param {boolean} [forceBedrockVerification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetailsWithDirectCredential(credentialKey: GetArticleDetailsWithDirectCredentialCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDetailsResponse> {
            return localVarFp.getArticleDetailsWithDirectCredential(credentialKey, articleId, forceBedrockVerification, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the current SeekingAlpha rating snapshot (quant, authors, sell-side and factor grades) for a comma-separated list of ticker symbols. Cached server-side; unavailable tickers are returned with available=false.
         * @summary Get current ratings for multiple tickers
         * @param {string} tickers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentRatings(tickers: string, options?: RawAxiosRequestConfig): AxiosPromise<CurrentRatingsResponse> {
            return localVarFp.getCurrentRatings(tickers, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the latest published stock articles from SeekingAlpha
         * @summary Get latest published stock articles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPublishedStock(options?: RawAxiosRequestConfig): AxiosPromise<Array<SimpleArticle>> {
            return localVarFp.getLatestPublishedStock(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve market cap value for a specific ticker symbol from SeekingAlpha
         * @summary Get market cap for ticker
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketCap(ticker: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getMarketCap(ticker, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the rating histories (quant, authors, sell-side ratings and factor grades) for a specific ticker symbol from SeekingAlpha
         * @summary Get rating histories for ticker
         * @param {string} ticker 
         * @param {number} [pageNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingHistories(ticker: string, pageNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<RatingHistoriesResponse> {
            return localVarFp.getRatingHistories(ticker, pageNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve Pro Quant Portfolio articles as simplified article list from SeekingAlpha
         * @summary Get simplified Pro Quant Portfolio articles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimpleProQuantPortfolioArticles(options?: RawAxiosRequestConfig): AxiosPromise<Array<SimpleArticle>> {
            return localVarFp.getSimpleProQuantPortfolioArticles(options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger the SeekingAlpha scheduled trading task manually, bypassing the first working day validation. Optional simulation parameters allow testing with a specific article.
         * @summary Manually trigger scheduled trading task
         * @param {TriggerScheduledTaskCredentialKeyEnum} [credentialKey] 
         * @param {TriggerScheduledTaskRunModeEnum} [runMode] 
         * @param {string} [mockArticleId] 
         * @param {number} [mockInjectAtAttempt] 
         * @param {number} [parallelJobs] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerScheduledTask(credentialKey?: TriggerScheduledTaskCredentialKeyEnum, runMode?: TriggerScheduledTaskRunModeEnum, mockArticleId?: string, mockInjectAtAttempt?: number, parallelJobs?: number, options?: RawAxiosRequestConfig): AxiosPromise<ScheduledTaskTriggerResponse> {
            return localVarFp.triggerScheduledTask(credentialKey, runMode, mockArticleId, mockInjectAtAttempt, parallelJobs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SeekingAlphaApi - object-oriented interface
 * @export
 * @class SeekingAlphaApi
 * @extends {BaseAPI}
 */
export class SeekingAlphaApi extends BaseAPI {
    /**
     * Retrieve detailed information for a specific article by ID from SeekingAlpha
     * @summary Get article details
     * @param {GetArticleDetailsCredentialKeyEnum} credentialKey 
     * @param {string} articleId 
     * @param {boolean} [forceBedrockVerification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getArticleDetails(credentialKey: GetArticleDetailsCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getArticleDetails(credentialKey, articleId, forceBedrockVerification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information for a specific article by ID from SeekingAlpha using direct credential lookup (bypassing cache)
     * @summary Get article details with direct credential lookup
     * @param {GetArticleDetailsWithDirectCredentialCredentialKeyEnum} credentialKey 
     * @param {string} articleId 
     * @param {boolean} [forceBedrockVerification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getArticleDetailsWithDirectCredential(credentialKey: GetArticleDetailsWithDirectCredentialCredentialKeyEnum, articleId: string, forceBedrockVerification?: boolean, options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getArticleDetailsWithDirectCredential(credentialKey, articleId, forceBedrockVerification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the current SeekingAlpha rating snapshot (quant, authors, sell-side and factor grades) for a comma-separated list of ticker symbols. Cached server-side; unavailable tickers are returned with available=false.
     * @summary Get current ratings for multiple tickers
     * @param {string} tickers 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getCurrentRatings(tickers: string, options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getCurrentRatings(tickers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the latest published stock articles from SeekingAlpha
     * @summary Get latest published stock articles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getLatestPublishedStock(options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getLatestPublishedStock(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve market cap value for a specific ticker symbol from SeekingAlpha
     * @summary Get market cap for ticker
     * @param {string} ticker 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getMarketCap(ticker: string, options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getMarketCap(ticker, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the rating histories (quant, authors, sell-side ratings and factor grades) for a specific ticker symbol from SeekingAlpha
     * @summary Get rating histories for ticker
     * @param {string} ticker 
     * @param {number} [pageNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getRatingHistories(ticker: string, pageNumber?: number, options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getRatingHistories(ticker, pageNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve Pro Quant Portfolio articles as simplified article list from SeekingAlpha
     * @summary Get simplified Pro Quant Portfolio articles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public getSimpleProQuantPortfolioArticles(options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).getSimpleProQuantPortfolioArticles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger the SeekingAlpha scheduled trading task manually, bypassing the first working day validation. Optional simulation parameters allow testing with a specific article.
     * @summary Manually trigger scheduled trading task
     * @param {TriggerScheduledTaskCredentialKeyEnum} [credentialKey] 
     * @param {TriggerScheduledTaskRunModeEnum} [runMode] 
     * @param {string} [mockArticleId] 
     * @param {number} [mockInjectAtAttempt] 
     * @param {number} [parallelJobs] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeekingAlphaApi
     */
    public triggerScheduledTask(credentialKey?: TriggerScheduledTaskCredentialKeyEnum, runMode?: TriggerScheduledTaskRunModeEnum, mockArticleId?: string, mockInjectAtAttempt?: number, parallelJobs?: number, options?: RawAxiosRequestConfig) {
        return SeekingAlphaApiFp(this.configuration).triggerScheduledTask(credentialKey, runMode, mockArticleId, mockInjectAtAttempt, parallelJobs, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetArticleDetailsCredentialKeyEnum = {
    SeekingAlphaProCookie: 'SeekingAlphaProCookie',
    SeekingAlphaPremiumCookie: 'SeekingAlphaPremiumCookie'
} as const;
export type GetArticleDetailsCredentialKeyEnum = typeof GetArticleDetailsCredentialKeyEnum[keyof typeof GetArticleDetailsCredentialKeyEnum];
/**
 * @export
 */
export const GetArticleDetailsWithDirectCredentialCredentialKeyEnum = {
    SeekingAlphaProCookie: 'SeekingAlphaProCookie',
    SeekingAlphaPremiumCookie: 'SeekingAlphaPremiumCookie'
} as const;
export type GetArticleDetailsWithDirectCredentialCredentialKeyEnum = typeof GetArticleDetailsWithDirectCredentialCredentialKeyEnum[keyof typeof GetArticleDetailsWithDirectCredentialCredentialKeyEnum];
/**
 * @export
 */
export const TriggerScheduledTaskCredentialKeyEnum = {
    SeekingAlphaProCookie: 'SeekingAlphaProCookie',
    SeekingAlphaPremiumCookie: 'SeekingAlphaPremiumCookie'
} as const;
export type TriggerScheduledTaskCredentialKeyEnum = typeof TriggerScheduledTaskCredentialKeyEnum[keyof typeof TriggerScheduledTaskCredentialKeyEnum];
/**
 * @export
 */
export const TriggerScheduledTaskRunModeEnum = {
    Live: 'LIVE',
    MockScannerRealBuy: 'MOCK_SCANNER_REAL_BUY',
    MockBoth: 'MOCK_BOTH'
} as const;
export type TriggerScheduledTaskRunModeEnum = typeof TriggerScheduledTaskRunModeEnum[keyof typeof TriggerScheduledTaskRunModeEnum];
